﻿"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const tslib_1 = require("tslib");
if (!Map.prototype.hasOwnProperty("getOrCreate")) {
    Map.prototype.getOrCreate = function (key, factory) {
        if (this.has(key)) {
            return this.get(key);
        }
        else {
            if (typeof factory === "function") {
                const value = factory();
                this.set(key, value);
                return value;
            }
            else {
                const value = factory.valueOf();
                this.set(key, value);
                return value;
            }
        }
    };
}
if (!Map.prototype.hasOwnProperty("getOrCreateAsync")) {
    Map.prototype.getOrCreateAsync = function (key, factory) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            if (this.has(key)) {
                return this.get(key);
            }
            else {
                if (typeof factory === "function") {
                    const value = yield factory();
                    this.set(key, value);
                    return value;
                }
                else {
                    const value = yield factory;
                    this.set(key, value);
                    return value;
                }
            }
        });
    };
}
